import Vue from 'vue'
import App from './Approute.vue'
import vuetify from './plugins/vuetify'
import router from './router'; // 追記
import VueHead from 'vue-head'
import store from './store'

Vue.use(VueHead)

Vue.config.productionTip = false

function initialState () {
  return {
    doc_id    : "",
    title     : "",
    sub_title : "",
    summary   : "",
    ai_title     : "",
    ai_sub_title : "",
    ai_summary   : "",
    release_date : "",
    doc       : "",
    ai_doc    : "",
	editdata : "",
    direction : "",
    signature : "",
    conf_id   : "",
    schedule_id : "",
    loading_flg : false,
    save_flg  : false,
	migration : false,
	product_id : "",
	docstatus  : "",
	therm      : "",
	uuid       : "",
	temp_id    : "",
	share_flg  : false,
  };
}


// doc_info 追加
store.registerModule('doc_info', {
    namespaced: true,
    state : initialState,
    mutations: {
        reset(state){
            Object.assign(state, initialState());
        },
        set_val(state,obj){
            state.doc_id       = obj.doc_id;
            state.title        = obj.title;
            state.sub_title    = obj.sub_title;
            state.release_date = obj.release_date;
            state.summary      = obj.summary;
            state.doc          = obj.doc;
            state.direction    = obj.direction;
            state.signature    = obj.signature;
            state.conf_id      = Number(obj.conf_id);
            state.schedule_id  = obj.schedule_id;
            state.product_id   = obj.product_id;
            state.therm        = obj.therm;
            state.docstatus    = obj.docstatus;
            state.uuid         = obj.uuid;
            state.temp_id      = obj.temp_id;
            state.share_flg    = obj.share_flg;
        },
        set_doc(state,obj){
            state.title        = obj.title;
            state.sub_title    = obj.sub_title;
            state.release_date = obj.release_date;
            state.summary      = obj.summary;
            state.doc          = obj.doc;
            state.save_flg=false;
        },
        set_config(state,obj){
            state.direction = obj.direction;
            state.signature = obj.signature;
            state.conf_id   = Number(obj.conf_id);
        },
        set_doc_id(state,doc_id){
            state.doc_id   = doc_id;
        },
        set_ai_title(state,title){
            state.ai_title   = title;
        },
        set_ai_sub_title(state,sub_title){
            state.ai_sub_title   = sub_title;
        },
        set_ai_summary(state,summary){
            state.ai_summary   = summary;
        },
        set_ai_doc(state,doc){
            state.ai_doc   = doc;
        },
        set_schedule_id(state,schedule_id){
            state.schedule_id   = schedule_id;
        },
        set_product_id(state,product_id){
            state.product_id   = product_id;
        },
        set_docstatus(state,docstatus){
            state.docstatus   = docstatus;
        },
        set_editdata(state,obj){
            state.editdata   = obj;
        },
        set_loading(state,flag){
            state.loading_flg   = flag;
        },
        set_therm(state,therm){
            state.therm   = therm;
        },
        set_uuid(state,uuid){
            state.uuid   = uuid;
        },
        set_save(state){
            state.save_flg   = true;
        },
        set_migration(state){
            state.migration   = true;
        },
        set_temp_id(state,temp_id){
            state.temp_id   = temp_id;
        },
		set_ai_copy(state){
			state.doc = state.ai_doc;
		},
		set_share_flg(state,share_flg){
			state.share_flg = share_flg;
		},
    },
    getters : {
        get_doc_id : state => {
            return state.doc_id;
        },
        get_title : state => {
            return state.title;
        },
        get_subtitle : state => {
            return state.sub_title;
        },
        get_ai_title : state => {
            return state.ai_title;
        },
        get_ai_subtitle : state => {
            return state.ai_sub_title;
        },
        get_ai_summary : state => {
            return state.ai_summary;
        },
        get_release_date : state => {
            return state.release_date;
        },
        get_summary : state => {
            return state.summary;
        },
        get_doc : state => {
            return state.doc;
        },
        get_direction : state => {
            return state.direction;
        },
        get_ai_doc : state => {
            return state.ai_doc;
        },
        get_editdata : state => {
            return state.editdata;
        },
        get_signature : state => {
            return state.signature;
        },
        get_conf_id : state => {
            return state.conf_id;
        },
        get_schedule_id : state => {
            return state.schedule_id;
        },
        get_product_id : state => {
            return state.product_id;
        },
        get_docstatus : state => {
            return state.docstatus;
        },
        get_therm : state => {
            return state.therm;
        },
        get_uuid : state => {
            return state.uuid;
        },
        get_temp_id : state => {
            return state.temp_id;
        },
        get_loading : state => {
            return state.loading_flg;
        },
        get_save : state => {
            return state.save_flg;
        },
        get_migration : state => {
            return state.migration;
        },
        get_share_flg : state => {
            return state.share_flg;
        },
    },
});

store.registerModule('preview', {
    namespaced: true,
    state : { selected_word : ""},
    mutations: {
		set_word(state,word){
			state.selected_word = word;
		},
	},
    getters : {
        get_word : state =>{
            return state.selected_word;
        },
	},
});

store.registerModule('product_list', {
    namespaced: true,
    state : { product_list : [],loaded : false},
    mutations: {
		set_product_list(state,obj){
			state.product_list = obj;
		},
		set_load(state){
			state.loaded = true;
		},
	},
    getters : {
        get_product : state =>{
            return state.product_list;
        },
        get_load : state =>{
            return state.loaded;
        },
	},
});

store.registerModule('member_info', {
    namespaced: true,
    state : { pay_flg : false,cal_flg:false,user_kind : ""},
    mutations: {
		set_pay_flg(state,obj){
			state.pay_flg = obj;
		},
		set_cal_flg(state,obj){
			state.cal_flg = obj;
		},
		set_user_kind(state,obj){
			state.user_kind = obj;
		},
	},
    getters : {
        get_pay_flg : state =>{
            return state.pay_flg;
        },
        get_cal_flg : state =>{
            return state.cal_flg;
        },
        get_user_kind : state =>{
            return state.user_kind;
        },
	},
});

store.registerModule('favorite_block', {
    namespaced: true,
    state : { favlist : [] },
    mutations: {
		set_favlist(state,obj){
			state.favlist = obj;
		},
	},
    getters : {
        get_favlist : state =>{
            return state.favlist;
        },
	},
});

store.registerModule('update_block', {
    namespaced: true,
    state : { updated : [] , id : "" ,},
    mutations: {
        set_update(state,obj){
            state.updated = obj.data;
            state.id      = obj.id;
        },
    },
    getters : {
        get_update : state =>{
            return state.updated;
        },
        get_update_id : state =>{
            return state.id;
        },
    },
});

store.registerModule('mediacand', {
    namespaced: true,
    state : { candlist : [] ,},
    mutations: {
        set_candlist(state,obj){
            state.candlist = obj;
        },
    },
    getters : {
        get_candlist : state =>{
            return state.candlist;
        },
    },
});

store.registerModule('monitor', {
    namespaced: true,
    state : { navi_flg : false,},
    mutations: {
        set_navi_flg(state,obj){
            state.navi_flg = obj;
        },
    },
    getters : {
        get_navi_flg : state =>{
            return state.navi_flg;
        },
    },
});





new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
